import { Link, useParams } from 'react-router-dom'
import GamePage from '../../pages/GamePage'

const GamePageGuard = (props) => {
    const { pathname } = useParams() // must match your route param name

    // Games list still loading
    if (!props.games || props.games.length === 0) {
        return null
    }

    const game = props.games.find((g) => g.pathname === pathname)

    if (!game) {
        return (
            <div className='game-container visible'>
                <div className='age-wrapper'>
                    <h1>Game not found.</h1>
                    <Link className='button' to='/games'>
                        More Games
                    </Link>
                </div>
            </div>
        )
    }

    return <GamePage {...props} game={game} />
}

export default GamePageGuard